<!-- Experience Title -->
<dgx-profile-heading-v2
  *ngIf="!isPageLoading"
  [heading]="'Core_ExperiencesDisplayName' | translate"
  [hasItems]="!isEmpty"
  [viewAllUrl]="viewAllUrl"
  [viewAllUrlQueryParams]="viewAllUrlQueryParams"
  [showViewAll]="showViewAll"
  [ownerIsViewing]="ownerIsViewing"
>
  <button
    *ngIf="showAdd"
    class="l_flex--align-right"
    df-button
    dfButtonType="passive"
    (click)="addExperience($event)"
    data-dgat="profile-experience-header-589"
  >
    <div class="l_flexbar gap-full-half">
      <df-icon icon="plus"></df-icon>
      <div>{{ i18n.Core_Add }}</div>
    </div>
  </button>
</dgx-profile-heading-v2>

<section *ngIf="isPageLoading && useLoadingTemplate">
  <div class="guts-p-t-1-half">
    <dgx-skeleton type="mediumTitle"></dgx-skeleton>
    <div class="l_flex">
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 guts-p-l-0 m-guts-p-v-1-half m-guts-p-r-0"
      ></dgx-skeleton>
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 no-mobile"
      ></dgx-skeleton>
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 no-mobile"
      ></dgx-skeleton>
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 no-mobile guts-p-r-0"
      ></dgx-skeleton>
    </div>
  </div>
</section>

<!-- Empty State -->
<dgx-profile-section-empty-state-v2
  *ngIf="!isPageLoading && isEmpty"
  [ownerIsViewing]="ownerIsViewing"
  [isReadOnly]="isReadOnly"
>
  <a
    class="link"
    (click)="addExperience($event)"
    data-dgat="profile-experience-c9a"
  >
    <df-icon icon="plus-circle" size="large" class="add-btn__icon"></df-icon>
    <span class="par par--small l_flex-center font-bold add-btn__text">
      {{ 'dgProfileOverview_AddExperiences' | translate }}
    </span></a
  >
</dgx-profile-section-empty-state-v2>

<!-- Experiences Table -->
<div id="experiences-card" *ngIf="!isPageLoading && !isEmpty">
  <div *ngIf="!initialLoad" class="box m-guts-p-v-1-half guts-p-v-2">
    <div
      *ngFor="let experienceCollectionItem of experiences; let first = first"
      data-dgat="profile-experience-1f2"
      id="experience-{{ experienceCollectionItem.content.userPositionId }}"
    >
      <div *ngIf="experienceCollectionItem?.content as experience">
        <div
          *ngIf="!first"
          class="divider guts-m-h-2 m-guts-m-h-0 guts-p-v-1-half"
        ></div>
        <div class="m-guts-p-h-1-half guts-p-h-2">
          <!-- Experience Header -->
          <div class="l_flex m-l_flex profile-experience__header">
            <div class="l_flex m-l_flex l_flex-center-children">
              <div class="guts-m-h-1 m-no-guts center-item">
                <div class="icon-spot bg-color-sky-light color-sky-dark">
                  <df-icon icon="experience"></df-icon>
                </div>
              </div>
              <div class="guts-p-r-half m-guts-p-l-half">
                <h3
                  class="h3"
                  [dgxLineClampText]="experience.title"
                  [clampLinesMax]="1"
                ></h3>
                <div
                  class="par par--small par--light"
                  [dgxLineClampText]="getSubHeading(experience)"
                  [clampLinesMax]="1"
                ></div>
              </div>
            </div>
            <div
              class="
                l_flex
                m-l_flex
                l_flex-center-children
                guts-p-full-0 guts-m-l-auto
              "
            >
              <div
                *ngIf="experience.tags?.length"
                class="
                  badge badge-pill badge-neutral
                  guts-m-v-half
                  no-mobile
                  skill-count
                "
              >
                {{ this.getPillSkillCount(experience.tags) }}
              </div>
              <button
                *ngIf="canToggleDetailsSection(experience)"
                type="button"
                (click)="toggleDetails(experience.userPositionId)"
                attr.aria-expanded="{{ isOpen[experience.userPositionId] }}"
                data-dgat="profile-experience-header-cc5"
                class="guts-m-h-1"
              >
                <df-icon
                  class="color-ebony-a61 guts-m-h-1"
                  size="medium"
                  [icon]="
                    isOpen[experience.userPositionId]
                      ? 'chevron-up'
                      : 'chevron-down'
                  "
                ></df-icon>
              </button>
              <div
                [ngClass]="{ 'experience-actions-empty-state': !userLoggedIn }"
              >
                <dgx-user-experience-actions
                  *ngIf="userLoggedIn"
                  [userExperience]="experienceCollectionItem"
                  (itemEdited)="getExperiences(false, false)"
                ></dgx-user-experience-actions>
              </div>
            </div>
          </div>
          <!-- END: Experience Header -->

          <!-- Experience Details -->
          <div class="profile-experience__details">
            <div *ngIf="isOpen[experience.userPositionId]">
              <div
                *ngIf="experience.description"
                class="guts-m-t-1 guts-m-b-1-half par par--small par--light"
                [dgxLineClampText]="experience.description"
                [clampLinesMax]="8"
              ></div>
              <div
                *ngIf="canAddDescription(experience.description)"
                class="guts-m-v-half"
              >
                <button
                  class="link font-bold zeta"
                  (click)="editExperience(experience)"
                  data-dgat="profile-experience-details-1f7"
                >
                  <div class="l_flexbar gap-full-half">
                    <df-icon icon="plus"></df-icon>
                    <div>{{ i18n.dgProfileOverview_AddDescription }}</div>
                  </div>
                </button>
              </div>
              <div *ngIf="experience.tags.length">
                <div
                  *ngFor="let tag of getVisibleSkills(experience.tags)"
                  class="
                    btn btn-sm
                    disabled
                    bg-color-ebony-a08
                    color-ebony
                    guts-m-l-quart guts-m-t-half guts-m-r-half guts-p-r-half
                    break
                  "
                  data-dgat="profile-experience-6cf"
                >
                  {{ tag.title }}
                </div>
                <div
                  *ngIf="experience.tags.length > skillLimit"
                  class="
                    btn btn-sm
                    disabled
                    bg-color-ebony-a08
                    color-ebony
                    guts-m-l-quart guts-m-t-half guts-m-r-half guts-p-r-half
                  "
                  data-dgat="profile-experience-79f"
                >
                  {{ getHiddenSkills(experience.tags) }}
                </div>
              </div>
              <div *ngIf="canAddSkills(experience.tags)" class="guts-m-v-half">
                <button
                  class="link font-bold zeta"
                  (click)="editExperience(experience)"
                  data-dgat="profile-experience-details-235"
                >
                  <div class="l_flexbar gap-full-half">
                    <df-icon icon="plus"></df-icon>
                    <div>{{ i18n.Core_AddTags }}</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <!-- END: Experience Details -->
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="sectionLoading && pageType === 'Experiences'">
    <div>
      <dgx-skeleton type="experiencesTable"></dgx-skeleton>
    </div>
  </div>

  <div
    class="center-text guts-m-t-1-half"
    *ngIf="hasMoreItems && useShowMore && !initialLoad"
  >
    <button
      df-button
      dfButtonType="passive"
      class="show-more-btn"
      (click)="getExperiences(false, true)"
      data-dgat="profile-skill-signal-page-a04"
    >
      <df-spinner-button [isSpinning]="sectionLoading">
        {{ 'Core_ShowMore' | translate }}
      </df-spinner-button>
    </button>
  </div>
</div>
